var _image, _image2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.01,
    height: 48.01,
    viewBox: "0 0 1015 1015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 1015,
    height: 1015,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAcElEQVRoge3asQ2AMBAEwcMipf8KoQEXALJTClidtBN+9JvfkeROcqXTXAFv6fPbWBW/a485ip/fDKAZQDOAZgDNAJoBNANoBtAMoBlAM4BmAM0AmgE0A2gG0AygGUAzgGYAzQBa/djjTPLUzm2S+QE9WQgP+ead8QAAAABJRU5ErkJggg=="
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    x: 2,
    y: 2,
    width: 1011,
    height: 1011,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB4ElEQVRoge2azytEURTHPzNDfoT8KmUn/4CFWNja2bImSnZ2/gdLCxspopCtsrEnsZWtiJSiZkSiubrTW8h5M93z5o3r1f3Ua6Zzzrv3fLu/zm0mZ4y5BzrJJiUrwGQ0+Qp5q0JYs0Mpn+HkKwQBvgkCfBME+CYI8E0Q4JumhP0/AdvAGVAUXh0dwDgwCwyq3zbGFI2OXWNMpy1iU37ajDEbylyKWgFHDUj897Mveq1OMVdR4Xah+QB6gTfhSRe7Ll+ALodWVeX0gWPy7cCAsLpTBnZcozUCzoUlHnvDuwBWY71uXDZCQFlY4nmPdrcV4AQYio2qjfM1VyNAs+U+Rp+TwDWwICJq49xXow6ywo/vLcAmcAj0i8g6+cuTeCY6AJeBnPAmxEcp0SIsdZC0lEjCMbAE3KXZaKNG4PeOZafNVNrJoxyBL2GpTl/kOQUWgauqkfE496UZAdeF1xrN83VgIkHyKjQjMCos8RSi8vgm1uvGiGugppizdVA38Ck86fMM9Di0qirmbJG2J6zps+WYfAXtLjQNbADNwlM/do2tAXOaljRT6Ce3UXlgK9RX4dVhR3YMmAeGle+Wkgr4L4TfB7wTBPgmCPBNEOCbIMA3mReQ+T972BvZQ2aLOSh9A5LxojYTH7f7AAAAAElFTkSuQmCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.634af68456aef6752ebe56187fe52ad0.svg";
export { ForwardRef as ReactComponent };